module.exports = __webpack_public_path__ + "static/media/get-started-call.1b3570b4.svg";